/* eslint-disable react/prop-types */
import classnames from "classnames";

const FormCancelButton = ({
  text,
  disabled = false,
  onClick,
  isDanger = false,
  htmlType = "submit",
  icon = false,
  fullWidth = false,
}) => {
  return (
    <button
      type={htmlType}
      onClick={onClick}
      disabled={disabled}
      className={classnames(
        "flex items-center gap-2 my-2 border border-gray-300 text-gray-600  text-sm px-4 py-2 rounded-md  hover:bg-gray-100 cursor-pointer transition",
        {
          "w-full": fullWidth,
          "text-red-600 border-red-600": isDanger,
        }
      )}
    >
      {icon && icon}
      {text}
    </button>
  );
};

export default FormCancelButton;
